export default __webpack_public_path__ + "static/media/7minfitness@2x.12ce7597.jpg";